import React from 'react';

import { useIntl } from 'react-intl';

import { useCreateAllowList } from 'src/features/parkingManagement/api/AllowListAPI/useCreateAllowList';
import { LIST_ALLOW_LISTS_RESOURCE } from 'src/features/parkingManagement/api/AllowListAPI/useListAllowLists';
import AllowListFormModal from 'src/features/parkingManagement/components/AllowLists/forms/AllowListFormModal';
import { allowListMessages } from 'src/features/parkingManagement/utils/allowListMessages';
import { ICON_MAP } from 'src/features/parkingStatus/utils';
import { queryClient } from 'src/lib/react-query';
import { useParking } from 'src/providers/ParkingProvider';
import { type DataTableNewEntryProps } from 'src/registry/components/table/types';
import { toast } from 'src/registry/hooks/UseToast';
import { generalMessages } from 'src/utils/messages';

import type { AllowList } from 'src/features/parkingManagement/types/allowList';

interface CreateEntityGroupFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

export default function CreateAllowListFormModal<TData>({
    className,
    semantics,
}: CreateEntityGroupFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { parkingId } = useParking();
    const { mutate, isPending } = useCreateAllowList({
        onSuccess: ({ name }: AllowList) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_ALLOW_LISTS_RESOURCE] });
            toast({
                title: formatMessage(allowListMessages.createAllowListSuccess),
                description: formatMessage(allowListMessages.createAllowListSuccessDescription, { entry: name }),
            });
        },
    });

    return (
        <AllowListFormModal
            className={className}
            mutate={(values, onSuccess) => mutate({ parkingId, ...values }, { onSuccess })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(allowListMessages.createAllowListModalSubtitle)}
        />
    );
}
